import api from "../../../../../../api/axios"
import { BankAccount } from "../../../../../../legacyComponents/util/api/apis/customer"

export default async function submitBankAccount(values, user, employer, account) {
	console.log("In submitBankAccount, values = ", values)
	let { bank, isBillingAccount } = values
	if (values?.bank?.routingNumber?.length > 9) {
		values.bank.routingNumber = values.bank.routingNumber?.substring(0, 9)
	}
	if (account?.routingNumber?.length > 9) {
		account.routingNumber = account.routingNumber?.substring(0, 9)
	}
	// console.log("Processed routing number:", account?.routingNumber)

	if (account?.id) bank = await updateAccount(values, employer, account)
	else bank = await createAccount(values, employer)

	const useForBilling = isBillingAccount === "Yes"
	await setReimbursementAccount(bank, employer, useForBilling)
//	if (isBillingAccount === "Yes") await setBillingAccount(bank, employer)
}

async function createAccount(values, employer) {
	try {
		const { bankName, nickname, accountType, accountNumber, routingNumber } = values

		const payload = {
			//...bank,
			bankName,
			nickname,
			accountType,
			accountNumber,
			routingNumber,
		}

		const params = { employerId: employer?.id, nickname }
		
		const { data: employerBankData } = await api.post(`employer/${params.employerId}/bankAccount`,payload)
		
		return new BankAccount(employerBankData)
		
	} catch (error) {
		console.error(error)
	}
}

async function updateAccount(values, employer, account) {
	const { bank, bankName, nickname, accountType, accountNumber } = values

	const payload = {
		...bank,
		bankName,
		nickname,
		accountType,
		accountNumber
	}

	const url = `employer/${employer?.id}/bankAccount/${account?.id}`
	const response = await api.patch(url, payload)

	return response?.data
}

async function setReimbursementAccount(bank, employer, useForBilling) {
	const payload = {
//		id: bank?.id,
		use: "employeeReimbursements",
		useForReimbursements: true,
		useForBilling: useForBilling,
	}
	await api.post( `employer/${employer.id}/account/${bank?.id}`,payload)
}
